import * as React from "react";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Divider } from "@mui/material";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import RssFeedIcon from "@mui/icons-material/RssFeed";
import { useDispatch, useSelector } from "react-redux";
import { getAllBookPackages } from "../../src/api/browserGetPackage";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useNavigate } from "react-router-dom";
import objectToQueryString from "../../src/screens/browseJournal/objToQuery";
import { browseJournalSearchResult } from "../../src/store/slice/browsePackage";
import {
  updateBrowserPage,
  updateBrowserRow,
  updateBrowserSearch_term,
  updateBrowserSearch_type,
} from "../../src/store/slice/browseFilterSlicePackage";
import { goToTop } from "../../src/utils/helper";
import Pagination from "../components/pagination";
import NoResultModal from "../components/modals/NoResultFound";
import { clearAllFilters } from "../../src/store/slice/filterSlice";
import {
  updateSort,
  updateSortName,
  updateBrowserRow as updateBrowserRowAtoZ,
  updateBrowserPage as updateBrowserPageAtoZ,
} from "../../src/store/slice/browseFilterSlice";
import { getContainOrStartingWIth as getContainOrStartingWIthforPublisher } from "../../src/store/slice/browserPublisher";
import { getContainOrStartingWIth } from "../../src/store/slice/browseJournal";

function createData(name: string) {
  return {
    name,
  };
}

export default function Packages(props: any) {
  const navigate = useNavigate();

  const infoCustomerId =
    useSelector((state: any) => state.login?.informaticscustomer_id) ||
    sessionStorage.getItem("informaticscustomer_id");

  const searchReducer: any = useSelector((state: any) => state);
  const [userData, setUserData] = React.useState<any>({});
  const [journalSearchResults, setJournalSearchResults] = React.useState<any[]>(
    []
  );
  const [AllNoOfResults, setAllNoOfResults] = React.useState(0);
  const [loading, setLoading] = React.useState(true);
  const [renderFlag, setRenderFlag] = React.useState(true);

  const [noresultModal, setNoResultModal] = React.useState<any>(false);
  let selectedLetterTags = Array(28).fill(false);

  const [selectedTags, setSelectedTags] =
    React.useState<boolean[]>(selectedLetterTags);

  const [apipage, setApiPage] = React.useState(1);
  const dispatch = useDispatch();

  const packageHits = useSelector(
    // @ts-ignore
    (state) => state?.browsePackage?.browserResult
  );

  const search_type = useSelector(
    // @ts-ignore
    (state) => state?.browseFilterSlicePackage.search_type
  );

  const search_term = useSelector(
    // @ts-ignore
    (state) => state?.browseFilterSlicePackage.search_term
  );

  const rows = useSelector(
    // @ts-ignore
    (state) => state?.browseFilterSlicePackage.rows
  );

  const currentPage = useSelector(
    // @ts-ignore
    (state) => state?.browseFilterSlicePackage.page
  );

  let count = Math.ceil(packageHits?.hits / rows);
  const search_terms = useSelector(
    // @ts-ignore
    (state) => state?.browseFilterSlicePackage
  );

  React.useEffect(() => {
    setUserData(searchReducer);
    dispatch(updateSort("resource_name_tk asc"));
    dispatch(updateSortName("Journal"));
    dispatch(updateBrowserRowAtoZ(15));
    dispatch(updateBrowserPageAtoZ(1));
    dispatch(getContainOrStartingWIth("Starting With"));
    dispatch(getContainOrStartingWIthforPublisher("Starting With"));
  }, []);

  const fetchBookPackageResults = async () => {
    let apiJournalData: any = {
      client_id: infoCustomerId,
      p_page_size: rows,
      p_page_number: currentPage,
    };
    if (search_type !== "") {
      Object.assign(apiJournalData, { search_type: search_type });
    }
    if (search_type == "") {
      Object.assign(apiJournalData, { search_type: "2" });
    }
    if (search_term !== "") {
      Object.assign(apiJournalData, { search_term: search_term });
    }
    let response = await getAllBookPackages(
      objectToQueryString(apiJournalData)
    );
    if (response?.data.data[0][0]?.data === null) {
      setLoading(false);
      setRenderFlag(false);
      setNoResultModal(true);
    } else {
      setApiPage(apipage + 1);
      setJournalSearchResults([
        ...journalSearchResults,
        ...response?.data.data[0][0]?.data,
      ]);
      dispatch(browseJournalSearchResult(response?.data?.data[0][0]));
      setLoading(false);
      setAllNoOfResults(response?.data.data[0][0]?.hits);
    }
  };
  const stableSearch_term = React.useMemo(
    () => search_term,
    [JSON.stringify(search_term ? search_term : [])]
  );

  React.useEffect(() => {
    const debounce = setTimeout(() => {
      fetchBookPackageResults();
    }, 100);

    return () => {
      clearTimeout(debounce);
    };
  }, [stableSearch_term, currentPage, rows]);

  function handlePageChange(p: any) {
    dispatch(updateBrowserPage(p));
    goToTop();
  }

  function getRowsPerPage(value: number) {
    dispatch(updateBrowserRow(value));
  }

  async function closeNoResultModal() {
    dispatch(clearAllFilters());
    let temp = Array(28).fill(false);
    props.setKeyWordPackage("");
    props.setSelectedTagPackage("");
    props.setSelectedLetterTagsPackage(temp);
    dispatch(updateBrowserSearch_term([]));
    setNoResultModal(false);
  }

  return (
    // <Box sx={{ width: "133%" }}>
    <Box sx={{ width: { xs: "100%", sm: "100%", md: "100%" } }}>
      <TableContainer component={Paper} sx={{ marginTop: "2%" }}>
        <Table aria-label="collapsible table">
          <TableHead>
            <TableRow sx={{ backgroundColor: "#F9FAFB" }}>
              <TableCell>Package Name</TableCell>

              <TableCell align="right"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {packageHits?.data &&
              packageHits?.data?.map((e: any) => (
                <TableRow
                  onClick={() =>
                    navigate("/BookSearch/PackageArticle", {
                      state: {
                        packageId: e?.package_id,
                        // packageName: e?.package_name,
                        //   publisherId:
                        //     element?.doclist?.docs[0]?.publisher_id[0],
                        publisherName: e?.package_name,
                        publisherFilter: props.filters,
                        packageDetails: e?.doclist?.docs[0],
                        from: "bookpackage",
                      },
                    })
                  }
                >
                  <TableCell sx={{ cursor: "pointer" }}>
                    {e.package_name}
                  </TableCell>
                  <TableCell sx={webStyles.rightAligncell}>
                    <ArrowForwardIosIcon
                      fontSize="small"
                      style={{ alignSelf: "center", cursor: "pointer" }}
                    ></ArrowForwardIosIcon>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box my={3} sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Pagination
          count={count}
          handlePageChange={handlePageChange}
          rowsPerResult={rows}
          getRowsPerPage={getRowsPerPage}
          currentPage={currentPage}
        />
      </Box>
      <NoResultModal isOpen={noresultModal} handleClose={closeNoResultModal} />
    </Box>
  );
}

const webStyles = {
  flexBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingTop: "0.3%",
    paddingBottom: "0.3%",

    alignContent: "center",
  },
  text: {
    fontSize: "0.875rem",
    alignSelf: "center",
  },
  subText: {
    fontFamily: "Helvetica Neue",
    fontSize: "1rem",
    paddingTop: "1%",
    paddingBottom: "1%",
    backgroundColor: "#f5f5f5",
  },
  rightAligncell: {
    textAlign: "right",
  },
};
